
<div class="relative grid grid-flow-dense grid-cols-1 lg:grid-cols-2 gap-4">
    <div class=" row-start-2 lg:row-start-1">
        <table class="text-sm text-left rtl:text-right col-span-1 h-min m-1">
            <thead class=" text-xs text-gray-700 uppercase border-b-2 border-gray-600">
            <tr>

                <th scope="col" class="px-3 py-3">

                </th>

                <th scope="col" class="px-3 py-3 max-w-32">
                    {{"ASSEMBLY_CONFIGURATOR.SPAN" | translate }}
                </th>

                <th scope="col" class="px-3 py-3 w-full">
                    <!--{{"ASSEMBLY_CONFIGURATOR.REINFORCEMENTS" | translate }}-->
                </th>

            </tr>
            </thead>
            <tbody class="max-h-96 overflow-y-scroll py-4">

                @for ( item of spacingComponents() | orderBy: 'index'; track $index; let i = $index;){

                    <tr class="border-b">

                        <th scope="row" class="relative px-6 py-4 text-gray-900 whitespace-nowrap font-bold ">

                            <span class="table-fixed top-0 left-0">L{{i+1}}</span>

                            <div class="absolute bottom-0 left-0 translate-y-1/2">
                                @if (item.span > 200){
                                    <button class="group items-baseline relative bg-secondary text-white rounded-full w-6 h-6 flex justify-center text-lg font-bold leading-none hover:bg-secondary-700"
                                            (click)="splitSpan(item.index)" >
                                        +
                                        <span class="absolute right-0 translate-x-[100%] bg-gray-700 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity w-45 p-4 ml-12">
                                            {{"ASSEMBLY_CONFIGURATOR.ADD_FRAME_SPACING" | translate }}
                                        </span>
                                    </button>
                                }

                            </div>
                        </th>

                        <td class=" px-3 py-4 h-0">
                            <input #spanValue type="text" class="appearance-none max-w-32 py-2 px-4 text-gray-700 leading-tight hover:bg-gray-200 focus:outline-none focus:bg-gray-100"
                                   [value]="item.span"
                                   (change)="handleSpanChange(item, spanValue)"
                            />
                        </td>

                        <td class="relative min-w-6">
                            @if(spacingComponents().length > 1) {
                                <div class="group  flex justify-end p-2">
                                    <button class="bg-gray-400 text-white rounded-full w-6 h-6 flex items-center justify-center text-lg font-bold leading-none hover:bg-gray-500"
                                            (click)="conjoinSpan(item.index)" >
                                        -
                                        <!--<span class="bg-gray-700 text-white text-xs rounded px-2 py-1 hidden opacity-0 group-hover:block group-hover:opacity-100 transition-opacity w-45 p-4 ml-12">Poista säleväli</span>-->
                                    </button>

                                </div>
                            }

                        </td>
                        <!--
                        <td class="px-3 py-4 ">
                            <app-checkbox [color]="'primary'" size="medium" [value]="item.reinforced" (change)="handleFrameReinforcementToggle(item.index)" />
                        </td>
                        -->
                    </tr>
                }

            </tbody>
        </table>
    </div>

    <app-card-wrap layout="row" class="h-fit border-none col-span-1 col-start-1 lg:col-start-2">

        <app-card-element [label]="('ASSEMBLY_CONFIGURATOR.OVERFLOW' | translate) + ':'" >

            @for ( item of overFlowComponents() | orderBy: 'index'; track item.index; let i = $index;){
                <div class="">

                    <label for="inputOverflow" class="font-bold text-sm capitalize">
                        @if (orientation() === 'horizontal') {
                            {{
                                ($first
                                    ? "GLOBAL.LEFT"
                                    : "GLOBAL.RIGHT")
                                | translate
                            }}
                        } @else {
                            {{
                                ($first
                                    ? "GLOBAL.BOTTOM"
                                    : "GLOBAL.TOP")
                                    | translate
                            }}
                        }
                    </label>

                    <app-input id="inputOverflow"
                               (valueChange)="handleOverflowChange(item, $event.value, $event.target)"
                               [inputPadding]="1"
                               [linkedValue]="item.span"
                               placeholder=""

                    />
                </div>
            }

        </app-card-element>

    </app-card-wrap>
</div>
